export const asProductId = (productIdString: string): number => {
  const parts = productIdString.split('/');
  return parseInt(parts[parts.length - 1]);
};
